import { useQuery } from '@tanstack/react-query';
import { parseVersion } from '@/services/versionUtils';
import { type AgentManifest, fetchAgentManifest } from '@/lib/agentManifest';

/**
 * Fetches the agent manifest.json from Front Door to determine the latest agent version.
 * The request always revalidates with the server so a stale browser copy is never used.
 * Parses the version and returns null if the format is invalid.
 */
export function useAgentManifest() {
  const { data, isLoading } = useQuery<AgentManifest | null>({
    queryKey: ['agent-manifest'],
    queryFn: () => fetchAgentManifest(),
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
    retry: 1,
  });

  // Parse and validate the version
  const rawVersion = data?.latestVersion ?? null;
  const parsed = parseVersion(rawVersion);

  return {
    latestVersion: parsed ? rawVersion : null,
    isLoading,
  };
}
